import React from 'react';

import { List } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';

import { NavListItem } from '../NavListItem';
import { NavListItemProps } from '../NavListItem/NavListItem';

export interface NavListProps {
  className?: string;
  items?: NavListItemProps[];
}

const useStyles = makeStyles((theme: Theme) => ({
  navList: {
    display: 'flex',
    flexFlow: 'column nowrap',
    width: '100%',

    '& .fd-list__item': {
      backgroundColor: theme.palette.common.white,
      borderTop: `1px solid ${theme.palette.grey[400]}`,
      transition: 'all 0.2s ease-out',

      '&:last-child': {
        borderBottom: `1px solid ${theme.palette.grey[400]}`,
      },

      '&:hover': {
        borderTop: `1px solid ${theme.palette.primary.main}`,

        '& + li': {
          borderTop: `1px solid ${theme.palette.primary.main}`,
        },
        '&:last-child:hover': {
          borderBottom: `1px solid ${theme.palette.primary.main}`,
        },
      },
    },
  },
}));

export function NavList(props: NavListProps): JSX.Element {
  const classes = useStyles();
  const { className = '', items } = props;

  const navListStyles = clsx('fd-list', classes.navList, className || '');

  return (
    <List className={navListStyles} component="ul">
      {items?.map((item) => (
        <NavListItem
          disabled={item.disabled}
          elements={item.elements}
          key={item.linkId}
          linkCallback={item.linkCallback}
          linkId={item.linkId}
          linkPath={item.linkPath}
          variant={item.variant}
        />
      ))}
    </List>
  );
}
